import { createSlice } from '@reduxjs/toolkit';
import generalEndpoints from 'app/api/services/generalEndpoints';
import { errorHandler } from 'app/utils/errorHandler';
import _ from 'lodash';

const initialState = {
  alertMessage: {},
  files: [],
  polos: [],
  cities: [],
  city: {},
  documentTypes: [],
  vehicles: [],
  deletedVehicles: [],
  internalNewRequest: {},
  orgaos:[],
  defaultOrgao:{}
};

const formsSlice = createSlice({
  name: 'forms',
  initialState,
  reducers: {
    setOrgaos(state, action) {
      state.orgaos = action.payload;
    },
    clearOrgaos(state, action) {
      state.orgaos = initialState.orgaos;
    },
    setFiles(state, action) {
      state.files = action.payload;
    },
    clearFiles(state, action) {
      state.files = initialState.files;
    },
    setAlertMessage(state, action) {
      state.alertMessage = action.payload;
    },
    clearAlertMessage(state, action) {
      state.alertMessage = initialState.alertMessage;
    },
    setCities(state, action) {
      state.cities = action.payload;
    },
    clearCities(state, action) {
      state.cities = initialState.cities;
    },
    setFilesByIndex(state, action) {
      const { data, index } = action.payload;
      if (state.files[index]) {
        const t = { ...state.files[index], ...data };
        state.files[index] = t;
      }
    },
    setBoExcluidoByIndex(state, action) {
      const { index } = action.payload;
      if (state.files[index]) {
        const temp = state.files[index];
        temp.boExcluido = true;
        if (temp.boAlterado !== null && temp.boAlterado !== undefined) {
          delete temp.boAlterado;
        }
        state.files[index] = temp;
      }
    },
    setCity(state, action) {
      state.city = action.payload;
    },
    clearCity(state, action) {
      state.city = initialState.city;
    },
    setPolos(state, action) {
      state.polos = action.payload;
    },
    clearPolos(state, action) {
      state.polos = initialState.polos;
    },
    setVehicles(state, action) {
      state.vehicles = action.payload;
    },
    clearVehicles(state, action) {
      state.vehicles = initialState.vehicles;
    },
    setVehicleByIndex(state, action) {
      const { data, vehicleIndex } = action.payload;
      if (state.vehicles[vehicleIndex]) {
        state.vehicles[vehicleIndex] = data;
      }
    },
    setDeletedVehicles(state, action) {
      state.deletedVehicles = action.payload;
    },
    clearDeletedVehicles(state, action) {
      state.deletedVehicles = initialState.deletedVehicles;
    },
    setInternalNewRequest(state, action) {
      state.internalNewRequest = action.payload;
    },
    clearInternalNewRequest(state, action) {
      state.internalNewRequest = initialState.internalNewRequest;
    },
    setDocumentTypes(state, action) {
      state.documentTypes = action.payload;
    },
    clearDocumentTypes(state, action) {
      state.documentTypes = initialState.documentTypes;
    },
    setDefaultOrgao(state, action){
      state.defaultOrgao = action.payload;
    }
  },
});

export const extractFileFromJson = (documents, initialValue = []) => async dispatch => {
  const tempFileStore = [...initialValue];

  if (documents) {
    documents.forEach(document => {
      let cdTipoDocumento = document.cdTipoDocumento;
      let linker = document.idFile;
      if (document.fileName && document.fileName.indexOf('CRLV') >= 0) {
        let temp = document.fileName.split('.');
        temp = temp[0].split('-');
        linker = temp.pop(); //CRLV-62-MKN8877
      }

      const fileFound = _.find(tempFileStore, ['cdTipoDocumento', cdTipoDocumento]);

      if (!fileFound) {
        if (document.idFile && !document.boExcluido) {
          const fileContent = {
            ...document,
            fieldname: `file-doc-${cdTipoDocumento}`,
            name: document.fileName,
            linker: linker,
          };
          tempFileStore.push(fileContent);
        }
      }
    });

    dispatch(setFiles(tempFileStore));
  }
};

export const fetchCities = uf => async dispatch => {
  try {
    let response = [];
    response = await generalEndpoints.getCities(uf);
    dispatch(setCities(response.data));
  } catch (error) {
    errorHandler(error.response?.status, error.response?.data?.message);
  }
};

export const fetchPolos = uf => async dispatch => {
  try {
    let response = [];
    response = await generalEndpoints.getPolos();
    dispatch(setPolos(response.data));
  } catch (error) {
    errorHandler(error.response?.status, error.response?.data?.message);
  }
};

export const fetchDocumentTypes = () => async dispatch => {
  try {
    const response = await generalEndpoints.getDocumentTypes();
    dispatch(setDocumentTypes(response.data));
  } catch (error) {
    errorHandler(error.response?.status, error.response?.data?.message);
  }
};

export const fetchOrgaos = () => async dispatch => {
  try {
    const response = await generalEndpoints.getOrgaos();
    dispatch(setOrgaos(response.data));
  } catch (error) {
    errorHandler(error.response?.status, error.response?.data?.message);
  }
}

export const fetchDefaultOrgao = () => async dispatch => {
  try {
    const response = await generalEndpoints.getOrgaoDefault();
    dispatch(setDefaultOrgao(response.data));
  } catch (error) {
    errorHandler(error.response?.status, error.response?.data?.message);
  }
}

export const {
  setFiles,
  clearFiles,
  setAlertMessage,
  clearAlertMessage,
  setFilesByIndex,
  setBoExcluidoByIndex,
  setCity,
  clearCity,
  setVehicles,
  clearVehicles,
  setContact,
  clearContact,
  setVehicleByIndex,
  setCities,
  clearCities,
  setPolos,
  clearPolos,
  setDeletedVehicles,
  clearDeletedVehicles,
  setInternalNewRequest,
  clearInternalNewRequest,
  setOrgaos,
  clearOrgaos,
  setDefaultOrgao,
  setDocumentTypes,
  clearDocumentTypes,
} = formsSlice.actions;

export default formsSlice;
